module.exports = __webpack_public_path__ + "img/login_close_up.24832039.png";